export function VisibilityOption({
  value,
  selected,
  onSelect,
  icon,
  title,
  description,
}: {
  value: "public" | "page_only" | "private";
  selected: string;
  onSelect: (value: "public" | "page_only" | "private") => void;
  icon: React.ReactNode;
  title: string;
  description: string;
}) {
  const isSelected = selected === value;

  return (
    <button
      type="button"
      onClick={() => onSelect(value)}
      className={`flex items-start gap-3 rounded-lg border p-4 text-left transition-all ${
        isSelected
          ? "border-primary bg-primary/5"
          : "border-border hover:bg-foreground/[0.03] hover:border-foreground/15 hover:shadow-sm"
      }`}
    >
      <div className={isSelected ? "text-primary" : "text-muted"}>{icon}</div>
      <div>
        <p className={`font-medium ${isSelected ? "text-primary" : "text-foreground"}`}>
          {title}
        </p>
        <p className="text-sm text-muted">{description}</p>
      </div>
    </button>
  );
}
